module.exports = __webpack_public_path__ + "img/domain.c051cae3.webp";